import React from 'react';
import pauseCircleFlowSrc from '../../assets/images/slide/pause-circle-flow.png';
import styles from './PauseSlideContentV4.css';

function PauseSlideContentV4() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseCircleFlowSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>We won’t ask about their favorite color</h2>
                <p className={styles.description}>Boundly’s psychology-informed questions adapt to every answer — revealing the choices, secrets and moments that shaped them</p>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV4
};
